import type { SedrPhase, SedrPhasesList } from '../../api/sedr';
import { sedrApi } from '../../api/sedr';
import { applyI18n } from '../../i18n';
import { renderPhasesStrip, showPhaseDialog } from './sedrPhases';

export function renderSedrPhasesPanel(options: {
  roomId: string;
  phasesList: SedrPhasesList;
  canWrite: boolean;
  onSelectPhase?: (phaseId: string | null) => void;
  onChanged: () => Promise<void> | void;
}): HTMLElement {
  const { roomId, canWrite, onSelectPhase, onChanged } = options;
  let phasesList = options.phasesList;
  let showArchived = false;

  const panel = document.createElement('div');
  panel.className = 'sedr-tab-panel sedr-phases-panel';

  const render = () => {
    panel.innerHTML = `
      <div class="sedr-phases-panel__header">
        <div>
          <h3 data-i18n="sedr.phases.title"></h3>
          <p class="muted" data-i18n="sedr.phases.pageSubtitle"></p>
        </div>
        <div class="sedr-phases-panel__actions">
          ${
            canWrite
              ? `<label class="checkbox-row">
                  <input type="checkbox" id="sedr-phases-show-archived" ${showArchived ? 'checked' : ''} />
                  <span data-i18n="sedr.phases.showArchived"></span>
                </label>
                <button type="button" class="button primary" id="sedr-phases-page-add" data-i18n="sedr.phases.add"></button>`
              : ''
          }
        </div>
      </div>
    `;

    const activeList: SedrPhasesList = showArchived
      ? phasesList
      : {
          phases: phasesList.phases.filter((p) => !p.archivedAt),
          unassignedRequirementCount: phasesList.unassignedRequirementCount,
        };

    const strip = renderPhasesStrip({
      list: activeList,
      canWrite,
      onEdit: canWrite
        ? (phase: SedrPhase) => {
            showPhaseDialog({ roomId, phase, onSaved: onChanged });
          }
        : undefined,
      onSelectPhase,
      omitHeader: true,
    });
    panel.append(strip);

    panel.querySelector('#sedr-phases-page-add')?.addEventListener('click', () => {
      showPhaseDialog({ roomId, onSaved: onChanged });
    });

    panel.querySelector('#sedr-phases-show-archived')?.addEventListener('change', (event) => {
      const checked = (event.target as HTMLInputElement).checked;
      showArchived = checked;
      void (async () => {
        if (showArchived) {
          phasesList = await sedrApi.listPhases(roomId, { archived: true });
        } else {
          phasesList = await sedrApi.listPhases(roomId);
        }
        render();
      })();
    });

    applyI18n(panel);
  };

  render();
  return panel;
}
